<template>
  <div class="app-inner-wrapper"
       :class="{'overflow-hidden-body': getOverflowState}"
  >
    <!-- Custom template 2 example -->
    <notifications group="custom-notification"
                   position="top center"
    >
      <template slot="body"
                slot-scope="props"
      >
        <div class="notification-template"
             :class="[props.item.type]"
        >
          <div class="notification-template-icon">
            <i :class="{
              'icon-tick-border':props.item.type =='success',
              'icon-warning-outline':props.item.type =='error' || props.item.type =='warning',
              'icon-info':props.item.type=='info' || !props.item?.type,
            }"
            />
          </div>
          <div class="notification-template-content">
            <!-- <p>
              {{props.item.title}}
            </p> -->
            <p @click="props.close"
               v-html="props.item.text"
            />
          </div>
          <div class="notification-template-close"
               @click="props.close"
          >
            <i class="icon-close-rounded" />
          </div>
        </div>
      </template>
    </notifications>

    <div v-if="showInfo" style="left: 0;right: 0;margin-inline: auto;width: fit-content;color: rgb(99, 18, 18);position: absolute;top: 0px;z-index: 99999;border-radius: 0px 0px 4px 4px;border: 1px solid rgb(242, 181, 181);background: rgb(248, 218, 218);padding: 8px;">
      Başka bir şirket hesabını yönetiyorsunuz: <b><i>"{{showCompanyInfo}}"</i></b>
    </div>

    <Layout v-if="resourceLoading" />

    <stackable-actions />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// eslint-disable-next-line import/no-extraneous-dependencies
// import { serviceWrapper, serviceConfigs } from '@/services/configs';
import ResourceManager from '@/services/resource.service';
// import { handleLoader } from '@/static/helpers/'
import { handleCookies } from '@/static/helpers';
import { jwtDecode } from 'jwt-decode';
import signalrService from './composables/signalrService';

export default {
  name: 'App',

  components: {
    Layout: () => import('./components/Layout.vue'),
    StackableActions: () => import('./components/layout/StackableActions.vue'),
  },

  data() {
    return {
      isOrientationPortrait: false,
      resourceLoading: false,
      // migrateInfoModalStatus: false,
    };
  },

  computed: {
    ...mapGetters(['getOverflowState']),
    showInfo() {
      const token = handleCookies.getCookie('hrvenue_identity');
      if (!token) {
        return false;
      }
      const decoded = jwtDecode(token);
      const isEqual = decoded['2E677C3FEEBEAE08B192C21D54785779D282E13E88B19FCA'] === decoded['8740759826996060'];
      return this.currentUser.isa && !isEqual;
    },
    showCompanyInfo() {
      const localStorageShowInfo = localStorage.getItem('showInfo');
      if (localStorageShowInfo !== 'undefined') {
        const showCompanyInfo = JSON.parse(localStorageShowInfo);
        return showCompanyInfo?.companyName || showCompanyInfo?.email || 'Şirket Adı Bulunamadı';
      }
      if (this.showInfo) {
        return 'Şirket Adı Bulunamadı';
      }
      return '';
    },
  },

  beforeCreate () {
    // if url has refresh query without a value, page gonna refresh
    if (handleCookies.getCookie('refresh')) {
      handleCookies.deleteCookie('refresh');
      location.reload();
    }
  },

  async created () {
    try {
      await signalrService.startConnection();
    } catch (error) {
      console.log(error);
    }

    ResourceManager.Get().then((res) => {
      this.callSetResource({
        ...res,
        ...{ CurrentLang: ResourceManager.CurrentLang },
      });
      this.resourceLoading = true;
    });
  },

  mounted() {
    this.enablePlugin();
  },

  methods: {
    ...mapActions([
      /* 'callToggleOverflowState', */
      'callAddOverflowState',
      'callRemoveOverflowState',
      'callSetResource',
    ]),

    closeCookieInfo() {
      localStorage.setItem('CookieStatus', true);
      this.getCookieInfoStatus();
    },

    getCookieInfoStatus() {
      this.cookieInfoStatus = !localStorage.getItem('CookieStatus');
    },

    detectWindowOrientation() {
      this.isOrientationPortrait = false;
      this.callRemoveOverflowState();

      if (window.innerWidth < 1025) {
        if (window.innerWidth > window.innerHeight) {
          // Landscape
          this.isOrientationPortrait = false;
          this.callRemoveOverflowState();
        } else {
          // Portrait
          this.isOrientationPortrait = true;
          this.callAddOverflowState();
        }
      } else {
        // Landscape
        this.isOrientationPortrait = false;
        this.callRemoveOverflowState();
      }
    },
    enablePlugin () {
      this.$gtm.enable(true);
    },
  },
};
</script>
<style lang="scss">
#chat-widget-container {
  display: none;
}
.page-job-detail,
.page-job-details,
.page-my-account {
  #chat-widget-container {
    display: block !important;
  }
}

#cookie-info {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  color: #ffffff;
  z-index: 999;
  i {
    float: right;
    cursor: pointer;
  }
  a {
    font-weight: bold;
    color: #ffffff;
    text-decoration: underline;
  }
}

.page-resume-pool {
  min-height: auto;
}

/*.migrate-info-text {*/
/*  line-height: 24px;*/
/*}*/

.demo-text-ln {
  line-height: 35px;
}
</style>
